import {
    getDataApi,
    postDataApi,
    putDataApi,
    deleteDataApi,
} from '../utils/fech-api';

const BASE_URL_MANAGE = '/api/admin/users';
const BASE_URL_GET = '/api/users';
const BASE_URL_SUPADMIN = '/api/supadmin/users';


// Fetch all users (for super admin)
export const fetchUsers = async ({ pageParam = 1, params = {}, headers = {} }) => {
    const resp = await getDataApi(BASE_URL_SUPADMIN, headers, { ...params, page: pageParam });
    return {
        data: resp.data,
        nextPage: resp.data.length > 0 ? pageParam + 1 : undefined,
    };
};

// Fetch a single user by ID
export const fetchUserById = (userId, headers = {}) => {
    return getDataApi(`${BASE_URL_MANAGE}/${userId}`, headers);
}

// Create a new user
export const createUser = (userData, headers = {}) => {
    return postDataApi(BASE_URL_SUPADMIN, userData, headers);
};

// Update a user (PUT request - full replacement)
export const updateUser = (userId, updatedData, headers = {}) => {
    return putDataApi(`${BASE_URL_MANAGE}/${userId}`, updatedData, headers);
};

// Partially update a user (PATCH request - status update)
export const updateUserStatus = (userId, status, headers = {}) => {
    return putDataApi(`${BASE_URL_SUPADMIN}/${userId}`, { status }, headers);
};

// Update user password
export const updateUserPassword = (userData, headers = {}) => {
    return putDataApi(`${BASE_URL_GET}/update/password`, userData, headers);
};

// Delete a user
export const deleteUser = (userId, headers = {}, params = {}) => {
    return deleteDataApi(`${BASE_URL_SUPADMIN}/${userId}`, headers, params);
};